<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
            <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div class="personal-bottom-bottom-right-top-left"></div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item class="maxtitle" :to="{ path: '/personalc' }">
                <div class="title_box">
                  <span class="lines"></span>
                  <span>我的粉丝</span>
                </div>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div v-show="guanzhuliebiao2" class="care_list">
              <div
                class="care_items"
                v-for="(item, index) in fensiData.list"
                :key="index"
              >
                <div class="care_items_row">
                  <div class="care_items_headers">
                    <img
                      :src="item.avatar"
                      alt=""
                    />
                  </div>
                  <div  class="care_items_right">
                    <div  class="name">{{ item.nickname }}</div>
                    <div  class="desc"> {{ item.desc ? item.desc : "主播还没有留下简介哦" }}</div>
                  </div>
                </div>
                <div class="care_btn_ok">
                  <div
                    @click="quxiaoguanzhu(item.uid)"
                    v-if="item.status == 2"
                  class="double_care"
                  >
                   <img
                      src="https://oss.ansongqiubo.com/assets/person/icon_huxiang@2x.png"
                      alt=""
                      srcset=""
                    />
                    <span>互相关注</span>
                  </div>
                  <div
                    @click="fansConcern(item.uid)"
                    v-if="item.status == 4"
                     class="redia_guanzhu"
                  >
                    <span>+ 关注</span>
                  </div>
                  <!-- <div
                    style="
                      margin-left: 15px;
                      color: #ffffff;
                      font-size: 14px;
                      width: 86px;
                      height: 36px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 4px;
                      border: 1px solid rgba(228, 228, 228, 1);
                    "
                  >
                    <span>发消息</span>
                  </div> -->
                </div>
              </div>
            </div>
            <div
              v-show="meiyguanzhu"
              style="
                margin-top: 90px;
                color: #d5d5d5;
                width: 100%;
                height: 100%;
                text-align: center;
              "
            >
              <img src="https://oss.ansongqiubo.com/assets/personimage/longzhu.png" alt="" />
              <div style="font-size: 18px; margin-top: 20px">
                你还没有关注的人，赶快去关注吧～
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import slide from './template_slide.vue'
import qs from "qs";
export default {
  name: "App",
  data() {
    return {
      b: 0,
      radio3: "男",
      text: "",
      textarea: "",
      value1: "",
      input: "",
      input1: "",
      input2: "",
      tishi: false,
      cooke: "",
      fensiData: [], //我的粉丝数据
      meiyguanzhu: false,
      guanzhuliebiao2: false,
      activeName: 0,
      useruid: null,
    };
  },
  created() {
    this.cooke = localStorage.getItem("token");
    if(this.cooke ){
      this.$store.dispatch('getUserInfoData').then((result) => {
        this.roomid(result.userInfo.uid);
      })
    }
  },
  methods: {
   changeSlide(data){
          this.$router.push(data);
        },
    roomid(e) {
      this.useruid = e;
      this.fensiliebiao(e)
    },
    fensiliebiao(e) {
      this.$axios
        .get(this.api + "/v1/relation/otfans?pageIndex=0&uid=" + e, {
          headers: {
            device: "iOS",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": this.cooke,
          },
        })
        .then((res) => {
          console.log(res);
          this.fensiData = res.data.data;
          if (this.fensiData.list && this.fensiData.list.length == 0) {
            this.meiyguanzhu = true;
            this.guanzhuliebiao2 = false;
          } else {
            this.meiyguanzhu = false;
            this.guanzhuliebiao2 = true;
          }
        });
    },
    // 取消关注
    quxiaoguanzhu(e) {
      // console.log(e);
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            // console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/relation/unfollow",
        method: "post",
        data: {
          actionUid: e,
        },
      }).then((res) => {
        if ((res.data.message = "success")) {
          this.fensiliebiao(this.useruid);
        }
      });
    },
    dianji(e) {
      this.b = e;
    },
    // 粉丝列表关注
    fansConcern(e) {
      // console.log(e);
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            //   console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/relation/follow",
        method: "post",
        data: {
          actionUid: e,
        },
      }).then((res) => {
        if ((res.data.message = "success")) {
          this.fensiliebiao(this.useruid);
        }
      });
    },
  },
  components: {
    Nav,
    slide
  },
};
</script>

<style scoped lang='scss'>
.xzcxzcxz {
  color: white;
}
.a {
  background-color: #721edc;
}
.sanjiao {
  width: 0;
  height: 0;
  border-top: 11px solid #ffffff;
  /* border-bottom-width: 11px; */
  /* border-radius: 0px; */
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  margin: 0 auto;
  margin-top: 15px;
}
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
  .title_box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .lines {
        display: inline-block;
        width: 4px;
        margin-right: 6px;
        border-radius: 4px;
        height: 20px;
        background: #721edc;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
    }
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
}
.personal-bottom-bottom-right-top {
  background-color: #fff;
  display: flex;
  align-items: center;
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }
}

.personal-bottom-bottom-right-bottom {
  height: calc(94% - 5px);
  margin-top: 25px;
  border-top: 1px solid rgba(218, 218, 218, 0.2);
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
    .care_list {
    width: calc(100% + 45px);
    height: calc(100% + 25px);
    overflow: scroll;
  }
  .care_btn_ok {
    width: 25%;
    display: flex;
    align-items: center;
  }
  .redia_guanzhu {
    cursor: pointer;
    margin-left: 15px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    justify-content: center;
    border: 1px solid rgba(228, 228, 228, 0.2);
    background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
    transition: all 0.1s;
    display: flex;
    justify-content: center;
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
  }
  .double_care {
    cursor: pointer;
    margin-left: 15px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    justify-content: center;
    border: 1px solid rgba(228, 228, 228, 0.21);
    background: #dadada;
     width: 98px;
      height: 36px;
      text-align: center;
      line-height: 36px;
          img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
    span {

      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  .double_care:hover{
    background: #fff0f0;
    span {
      color: rgba(237, 16, 16, 1);
    }
  }

  .care_items {
    display: flex;
    width: 100%;
    border-bottom: 1px solid rgba(218, 218, 218, 0.2);
  }
  .care_items_row {
    width: 75%;
    display: flex;
    align-items: center;
    margin: 20px 24px;
  }
  .care_items_right {
    display: flex;
    flex-direction: column;
    .name {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .desc {
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .care_items_headers {
    width: 70px;
    height: 70px;
    margin-right: 10px;
    border-radius: 50%;
    img {
      border-radius: 50%;

      width: 70px;
      height: 70px;
    }
  }
}
.maxtitle {
  font-size: 20px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600 !important;
  color: #333333;

  span {
    font-weight: 600 !important;
    color: #333333;
  }
}
.daohang {
  display: flex;
  color: white;
  width: 500px;
}

.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
</style>
<style>
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}
.personal-bottom-bottom-left .is-active {
  color: #721edc;
}
.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
}
</style>



// WEBPACK FOOTER //
// src/component/Wodefensi.vue